import { Box, ChakraProps } from '@chakra-ui/react';

interface CardProps {
  sx: ChakraProps['sx'];
}

const Card: React.FC<CardProps> = ({ children, sx }) => {
  return (
    <Box
      sx={sx}
      bg="white"
      p="16px"
      borderRadius={6}
      boxShadow="0px 0px 14px 0px rgb(53 64 82 / 5%)"
    >
      {children}
    </Box>
  );
};

export default Card;
